import React, { useState, useEffect, useMemo } from 'react';
import InfiniteScrollList from "../Common-components/InfiniteScrollList";
import ListItem from "../Common-components/listItem";
import "../../css/List/tabList.css";
import { usePageTitle } from '../../contexts/PageTitleContext';
import { ReactComponent as ArrowIcon } from '../../assets/icons/svg/arrowUnder.svg'

function BestList({ listData, pageTitle }) {
  const { setPageTitle } = usePageTitle(); // 모바일 header title 설정
  const sortOptions = [
    { label: "빠른일자순", value: "fastest" },
    { label: "느린일자순", value: "slowest" },
    { label: "높은가격순", value: "highest" },
    { label: "낮은가격순", value: "lowest" },
  ];

  const [selectedSort, setSelectedSort] = useState(sortOptions[0].value);
  const [isTablet, setIsTablet] = useState(window.innerWidth <= 1327);
  const [isSortDropdownOpen, setIsSortDropdownOpen] = useState(false);

  useEffect(() => {
    setPageTitle(pageTitle);

    const handleResize = () => {
      setIsTablet(window.innerWidth <= 1327);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [pageTitle, setPageTitle]);

  const transformItem = item => ({
      id: item.id,
      images: Array.isArray(item.images) ? item.images : [],
      departure: item.departure_port_name,
      destination: item.arrival_port_name,
      startDate: item.saildate,
      duration: item.nights ? `${item.nights}박 ${Number(item.nights) + 1}일` : "",
      ship: item.ship_name,
      ton: item.tonnage_label || "",
      price: item.price,
  });

  const hasData = Array.isArray(listData) && listData.length > 0;

  const sortedData = useMemo(() => {
    if (!hasData) return [];
    const list = listData.map(transformItem);

    const parseDateValue = (value) => {
      if (!value) return Number.POSITIVE_INFINITY;
      const time = Date.parse(value);
      return Number.isNaN(time) ? Number.POSITIVE_INFINITY : time;
    };

    const parsePriceValue = (value) => {
      if (value === null || value === undefined) return Number.POSITIVE_INFINITY;
      const numeric = parseFloat(value);
      return Number.isNaN(numeric) ? Number.POSITIVE_INFINITY : numeric;
    };

    switch (selectedSort) {
      case 'slowest':
        return list.sort((a, b) => parseDateValue(b?.startDate) - parseDateValue(a?.startDate));
      case 'highest':
        return list.sort((a, b) => parsePriceValue(b?.price) - parsePriceValue(a?.price));
      case 'lowest':
        return list.sort((a, b) => parsePriceValue(a?.price) - parsePriceValue(b?.price));
      case 'fastest':
      default:
        return list.sort((a, b) => parseDateValue(a?.startDate) - parseDateValue(b?.startDate));
    }
  }, [hasData, listData, selectedSort]);

  if (!hasData) {
      return <div>표시할 데이터가 없습니다.</div>;
  }
  
    return (
      <section className="list-section tab-list best">
        <div className="tab-list-wrapper">
          <div className="filter-sort-container">
            <h2 className="local-page-title">{pageTitle}</h2>
            <div className="sort-block">
              {isTablet ? (
                <div className="sort-dropdown">
                  <button
                    className="sort-dropdown-toggle"
                    onClick={() => setIsSortDropdownOpen(!isSortDropdownOpen)}
                  >
                    {sortOptions.find((option) => option.value === selectedSort)?.label}
                    <ArrowIcon />
                  </button>
                  {isSortDropdownOpen && (
                    <ul className="sort-dropdown-menu">
                      {sortOptions.map((option) => (
                        <li
                          key={option.value}
                          className={`sort-dropdown-item ${selectedSort === option.value ? "selected" : ""}`}
                          onClick={() => {
                            setSelectedSort(option.value);
                            setIsSortDropdownOpen(false);
                          }}
                        >
                          {option.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ) : (
                sortOptions.map((option) => (
                  <div
                    key={option.value}
                    className={`sort-option ${selectedSort === option.value ? "selected" : ""}`}
                    onClick={() => setSelectedSort(option.value)}
                  >
                    {option.label}
                  </div>
                ))
              )}
            </div>
          </div>

          <div className="tab-content">
              <InfiniteScrollList
                  data={sortedData}
                  renderItem={(item, index) => (
                      <div key={index} className="tab-item">
                          <ListItem item={item} />
                      </div>
                  )}
              />
          </div>
        </div>
      </section>
    );
}

export default BestList;
